export const getIntegrations = async apiCall => {
  try {
    const resp = await apiCall("/schema/integrations", "GET");
    return resp;
  } catch (error) {
    return null;
  }
};

export const getCapabilityList = async (apiCall, integration) => {
  return await apiCall(
    `/schema/capabilities?integration=${integration}`,
    "GET",
  );
};

export const getConfig = async (apiCall, id, env) => {
  return await apiCall(`/schema/config?id=${id}&env=${env}`, "GET");
};

export const getDetail = async (apiCall, id) => {
  return await apiCall(`/schema/capability?id=${id}`, "GET");
};

export const reloadSchema = async (
  apiCall,
  rebuild = false,
  env = "STAGING",
) => {
  const params = rebuild ? { rebuild, env } : { rebuild };
  return await apiCall("/schema/reload", "POST", params);
};

//save and reload

export const saveSchemaConfig = async (apiCall, config, environment) => {
  const resp = await apiCall("/schema/config/save", "POST", {
    config,
    environment,
  });
  return resp;
};
